import type { Template } from "@/types";

export const PO_06_H5_V1: Template[] = [
{
    id: "po-06-h5v1-01",
    name: "PO 01 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 34, y: 158, width: 318, height: 540, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 360, y: 158, width: 176, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 360, y: 295, width: 176, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 360, y: 432, width: 176, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 360, y: 569, width: 176, height: 129, rotation: 0, imageRotation: 0 },
            { id: "6", x: 609, y: 241, width: 487, height: 372, rotation: 0, imageRotation: 0 },
        ],
},

{
    id: "po-06-h5v1-02",
    name: "PO 02 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 50, y: 238, width: 221, height: 379, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 279, y: 238, width: 248, height: 186, rotation: 0, imageRotation: 0 },
        { id: "3", x: 279, y: 432, width: 248, height: 185, rotation: 0, imageRotation: 0 },
        { id: "4", x: 614, y: 162, width: 464, height: 348, rotation: 0, imageRotation: 0 },
        { id: "5", x: 614, y: 518, width: 229, height: 173, rotation: 0, imageRotation: 0 },
        { id: "6", x: 851, y: 518, width: 228, height: 173, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-03",
    name: "PO 03 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 41, y: 241, width: 487, height: 372, rotation: 0, imageRotation: 0 },
        { id: "2", x: 599, y: 158, width: 319, height: 540, rotation: 0, imageRotation: 0 },
        { id: "3", x: 926, y: 158, width: 176, height: 129, rotation: 0, imageRotation: 0 },
        { id: "4", x: 926, y: 295, width: 176, height: 129, rotation: 0, imageRotation: 0 },
        { id: "5", x: 926, y: 432, width: 176, height: 129, rotation: 0, imageRotation: 0 },
        { id: "6", x: 926, y: 569, width: 176, height: 129, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-04",
    name: "PO 04 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 81, y: 116, width: 410, height: 303, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 81, y: 427, width: 201, height: 152, rotation: 0, imageRotation: 0 },
        { id: "3", x: 81, y: 587, width: 201, height: 151, rotation: 0, imageRotation: 0 },
        { id: "4", x: 290, y: 427, width: 201, height: 152, rotation: 0, imageRotation: 0 },
        { id: "5", x: 290, y: 587, width: 201, height: 151, rotation: 0, imageRotation: 0 },
        { id: "6", x: 666, y: 116, width: 371, height: 623, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-05",
    name: "PO 05 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 54, y: 254, width: 461, height: 347, rotation: 0, imageRotation: 0 },
        { id: "2", x: 629, y: 66, width: 446, height: 313, rotation: 0, imageRotation: 0 },
        { id: "3", x: 629, y: 387, width: 220, height: 167, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 387, width: 219, height: 167, rotation: 0, imageRotation: 0 },
        { id: "5", x: 629, y: 562, width: 144, height: 225, rotation: 0, imageRotation: 0 },
        { id: "6", x: 781, y: 562, width: 295, height: 225, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-06",
    name: "PO 06 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_06.png",
    size: [1136, 854],
    style: {},
    slots: [        
        { id: "1", x: 0, y: 255, width: 226, height: 169, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 432, width: 226, height: 168, rotation: 0, imageRotation: 0 },
        { id: "3", x: 234, y: 255, width: 226, height: 169, rotation: 0, imageRotation: 0 },
        { id: "4", x: 234, y: 432, width: 226, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 468, y: 255, width: 204, height: 345, rotation: 0, imageRotation: 0 },
        { id: "6", x: 680, y: 255, width: 456, height: 345, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-07",
    name: "PO 07 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 181, width: 287, height: 493, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 295, y: 181, width: 169, height: 118, rotation: 0, imageRotation: 0 },
        { id: "3", x: 295, y: 307, width: 169, height: 117, rotation: 0, imageRotation: 0 },
        { id: "4", x: 295, y: 432, width: 169, height: 117, rotation: 0, imageRotation: 0 },
        { id: "6", x: 295, y: 557, width: 169, height: 117, rotation: 0, imageRotation: 0 },
        { id: "2", x: 472, y: 181, width: 665, height: 493, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-08",
    name: "PO 08 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 58, y: 541, width: 236, height: 172, rotation: 0, imageRotation: 0 },
        { id: "2", x: 58, y: 141, width: 236, height: 392, rotation: 0, imageRotation: 0 },
        { id: "3", x: 302, y: 141, width: 385, height: 282, rotation: 0, imageRotation: 0 },
        { id: "4", x: 302, y: 431, width: 385, height: 282, rotation: 0, imageRotation: 0 },
        { id: "5", x: 695, y: 141, width: 384, height: 282, rotation: 0, imageRotation: 0 },
        { id: "6", x: 695, y: 431, width: 384, height: 282, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-09",
    name: "PO 09 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 58, y: 144, width: 195, height: 307, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 261, y: 144, width: 405, height: 307, rotation: 0, imageRotation: 0 },
        { id: "3", x: 674, y: 144, width: 405, height: 307, rotation: 0, imageRotation: 0 },
        { id: "4", x: 58, y: 459, width: 335, height: 253, rotation: 0, imageRotation: 0 },
        { id: "5", x: 401, y: 459, width: 334, height: 253, rotation: 0, imageRotation: 0 },
        { id: "6", x: 743, y: 459, width: 336, height: 253, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-10",
    name: "PO 10 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_10.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 73, y: 120, width: 264, height: 200, rotation: 0, imageRotation: 0 },
        { id: "2", x: 73, y: 328, width: 264, height: 199, rotation: 0, imageRotation: 0 },
        { id: "3", x: 73, y: 535, width: 264, height: 199, rotation: 0, imageRotation: 0 },
        { id: "4", x: 345, y: 120, width: 363, height: 613, rotation: 0, imageRotation: 0 },
        { id: "5", x: 716, y: 120, width: 364, height: 303, rotation: 0, imageRotation: 0 },
        { id: "6", x: 716, y: 431, width: 364, height: 302, rotation: 0, imageRotation: 0 }
    ],
}
];